<template>
  <div class="job-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/job/bg.jpg"
      />

      <div
        class="section-container info-box wow animate__fadeIn"
        data-wow-duration="3000ms"
      >
        <p class="title">
          新的希望，就在你身边。<br />与我们并肩，拥抱激动人心的工作。
        </p>
        <p class="info">
          决定人生事业高度的因素，除了努力，还有许多。<br />选择正确的事业跑道，让成功事半功倍。<br />未来，现在就来。
        </p>
        <div class="button" @click="goPage">
          <p>立即探索</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "JobPage",
  data() {
    return {};
  },
  methods: {
    goPage() {
      window.open("http://newhope.zhiye.com/", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.job-container {
  position: relative;

  .info-box {
    top: 0;
    left: 50%;
    margin-left: -585px;
    position: absolute;
    height: 100%;
    box-sizing: border-box;
    padding: 70px 0 0 8%;

    .title {
      font-size: 28px;
      color: #1b5091;
    }

    .info {
      font-size: 16px;
      line-height: 32px;
      color: #565c61;
      margin-top: 50px;
    }
  }

  .button {
    background: #f3f3f4;
    width: 85px;
    height: 30px;
    border: 1px solid #565c61;
    outline: none;
    color: #565c61;
    font-size: 13px;
    line-height: 30px;
    font-weight: 400;
    border-radius: 1px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    text-align: center;
    position: relative;
    margin-top: 50px;

    &::before {
      content: "";
      width: 0;
      height: 100%;
      transition: all 0.3s ease-in-out;
      background-color: #565c61;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }

    &:hover {
      > p {
        color: #fff;
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      &::before {
        width: 100%;
      }
    }
  }
}
</style>
